import {Component,computed,effect,EventEmitter,input,Input,OnInit, Output, signal, ViewChild, WritableSignal } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';

import { HttpErrorResponse } from '@angular/common/http';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { ChemistryComponent } from './chemistry/chemistry.component';
import { MetalsComponent } from './metals/metals.component';
import { FilterState } from '../../../interfaces/generatorsmodel';

@Component({
  selector: 'app-labdata',
  imports: [MatTabsModule,ChemistryComponent,MetalsComponent],
  templateUrl: './labdata.component.html',
  styleUrl: './labdata.component.scss'
})
export class LabdataComponent implements OnInit {
  selectedIndex = input<number>(0);
  @Output() tabChange = new EventEmitter<number>();
  filterState = input<FilterState | null>(null);
  public refreshCounter: WritableSignal<number> = signal(0);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);

  private filterStatesMap = signal<Record<number, FilterState | null>>({});
  private searchQueriesMap = signal<Record<number, string | null>>({});

  public currentFilterState = computed(() => {
    const index = this.selectedIndex();
    return this.filterStatesMap()[index] || null;
  });

  public searchQuery = computed(() => {
    const index = this.selectedIndex();
    return this.searchQueriesMap()[index] || null;
  });


  constructor(){
    effect(() => { console.log('Incoming LabData filter:', this.filterState()); });
    effect(() => { console.log('Incoming LabData refreshTrigger:', this.refreshTrigger()); });
  }
  
  ngOnInit(): void {
    
  }

  onInnerTabChange(newIndex: number) {
    this.tabChange.emit(newIndex);
  }

}
